import { useEffect } from 'react';
import { Microsites } from 'constants/constants';
import { EventData } from 'services/Gtm/entities';
import { trackArticleLinkClick, trackInlineButtonClick } from 'utils/trackDataUtils';

/**
 * Fires a GA event when an inline button or a link is clicked on the recommends articles.
 * @param defaultTrackingData
 * @param subdomain
 */
export default function useTrackArticleClickEvents(defaultTrackingData: EventData, subdomain: string) {
  useEffect(() => {
    if (Microsites.Recommends !== subdomain) return () => {};

    const handleInlineButtonClick = (evt: Event) => {
      trackInlineButtonClick(evt, defaultTrackingData, subdomain);
    };

    const handleArticleLinkClick = (evt: Event) => {
      trackArticleLinkClick(evt, defaultTrackingData);
    };

    const anchorLinks = document.querySelectorAll('.wp-block-button>a');
    const articleAnchorLinks = document.querySelectorAll('.rawHtml-content a');

    anchorLinks.forEach((link) => {
      link.addEventListener('click', handleInlineButtonClick);
    });

    articleAnchorLinks.forEach((link) => {
      link.addEventListener('click', handleArticleLinkClick);
    });

    return () => {
      anchorLinks.forEach((link) => {
        link.removeEventListener('click', handleInlineButtonClick);
      });
      articleAnchorLinks.forEach((link) => {
        link.removeEventListener('click', handleArticleLinkClick);
      });
    };
  }, [defaultTrackingData, subdomain]);
}
